module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.forumTitle && _vm.$route.name !== 'course') ? _c('breadcrumbs', {
    attrs: {
      "breadcrumbs": [{
        title: 'Forum',
        link: '/forum'
      }, {
        title: _vm.forumTitle,
        link: '/discussion/' + this.forumId
      }]
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [(_vm.categories.term.length > 0) ? _c('div', {
    staticClass: "filters col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.termFilter),
      expression: "termFilter"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.termFilter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "default": "",
      "selected": ""
    }
  }, [_vm._v("Term")]), _vm._v(" "), _vm._l((_vm.categories.term), function(term) {
    return (term.topic_count > 0) ? _c('option', {
      domProps: {
        "value": term.id
      }
    }, [_vm._v("\n                            " + _vm._s(term.name) + "\n                            (" + _vm._s(term.topic_count) + ")\n                        ")]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pathFilter),
      expression: "pathFilter"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pathFilter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "default": "",
      "selected": ""
    }
  }, [_vm._v("Path")]), _vm._v(" "), _vm._l((_vm.categories.path), function(path) {
    return (path.topic_count > 0 && _vm.isInTerm(path.terms)) ? _c('option', {
      domProps: {
        "value": path.id
      }
    }, [_vm._v("\n                            " + _vm._s(path.name) + "\n                            (" + _vm._s(path.topic_count) + ")\n                        ")]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assignmentFilter),
      expression: "assignmentFilter"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.assignmentFilter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "default": "",
      "selected": ""
    }
  }, [_vm._v("Assignment")]), _vm._v(" "), _vm._l((_vm.categories.assignment), function(assignment) {
    return (assignment.topic_count > 0) ? _c('option', {
      domProps: {
        "value": assignment.id
      }
    }, [_vm._v("\n                            " + _vm._s(assignment.name) + "\n                            (" + _vm._s(assignment.topic_count) + ")\n                        ")]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 nopad"
  }, [_c('button', {
    staticClass: "btn btn-success clear-filters",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.termFilter = '';
        _vm.pathFilter = '';
        _vm.assignmentFilter = '';
        _vm.selectedTag = null
      }
    }
  }, [_vm._v("Clear Filters")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Threads"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Threads within a sub-forum, sometimes specific to a course'),
      expression: "'Threads within a sub-forum, sometimes specific to a course'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })])]), _vm._v(" "), (!_vm.threads || _vm.threads.length === 0) ? _c('div', {
    staticClass: "panel-body text-center noposts"
  }, [_vm._v("\n                No posts yet\n            ")]) : _c('div', {
    staticClass: "panel-body"
  }, [(_vm.subforums) ? _c('ul', {
    staticClass: "threads clearfix"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.threads), function(thread) {
    return (!_vm.selectedTag || _vm.isInTag(thread.forum_tags)) ? _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.noFilter || _vm.isInFilter(thread.forum_categories)),
        expression: "noFilter || isInFilter(thread.forum_categories)"
      }],
      staticClass: "row thread clearfix"
    }, [_c('div', {
      staticClass: "avatar-wrapper col-xs-1"
    }, [_c('img', {
      staticClass: "avatar-image",
      attrs: {
        "src": thread.poster.avatar
      }
    }), _vm._v(" "), (thread.sticky === true) ? _c('span', {
      staticClass: "sticky"
    }, [_vm._v("Sticky")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-5"
    }, [_c('span', {
      staticClass: "thread-name"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'thread',
          params: {
            forumId: _vm.forumId,
            topicId: thread.id
          }
        }
      }
    }, [_vm._v("\n                                    " + _vm._s(_vm._f("truncate")(thread.title, 50))), _c('br')])], 1), _vm._v("\n                            by\n                            "), _c('span', {
      staticClass: "post-author-link"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'posts-by-user',
          query: {
            userId: thread.poster.id
          }
        }
      }
    }, [_c('img', {
      staticClass: "role-icon",
      attrs: {
        "src": _vm._f("roleIcon")(thread.poster.roles, thread.poster.terms)
      }
    }), _vm._v("\n                                    " + _vm._s(thread.poster.firstName) + " " + _vm._s(thread.poster.lastName) + "\n\n                                ")])], 1), _vm._v("\n\n                            » " + _vm._s(_vm._f("shortDate")(thread.createdAt)) + "\n\n                            "), (thread.forum_categories.length > 0) ? _c('div', {
      staticClass: "categories"
    }, [_vm._v("Categories:\n                                "), _vm._l((thread.forum_categories), function(cat, $i) {
      return _c('span', [($i != 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "blue",
        class: {
          'bold': _vm.termFilter === cat.id || _vm.pathFilter === cat.id || _vm.assignmentFilter === cat.id
        },
        on: {
          "click": function($event) {
            _vm.setFilter(cat.type, cat.id)
          }
        }
      }, [_vm._v(_vm._s(cat.name) + "\n                                    ")])])
    })], 2) : _vm._e(), _vm._v(" "), (thread.forum_tags.length > 0) ? _c('div', {
      staticClass: "categories"
    }, [_vm._v("Tags:\n\n                                "), _vm._l((thread.forum_tags), function(tag, $i) {
      return _c('span', [($i != 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "blue",
        class: {
          'bold': _vm.selectedTag === tag.id
        },
        on: {
          "click": function($event) {
            _vm.selectedTag === tag.id ? _vm.selectedTag = null : _vm.selectedTag = tag.id
          }
        }
      }, [_vm._v(_vm._s(_vm._f("ucwords")(tag.name)))])])
    })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "stats-wrapper col-xs-3"
    }, [_vm._v("\n                            " + _vm._s(thread.post_count) + " posts"), _c('br'), _vm._v("\n                            " + _vm._s(thread.views) + " views\n                            "), (_vm.localStorage.roles.indexOf('Student') === -1 & _vm.localStorage.roles.indexOf('CampusStudent') === -1) ? _c('span', [(!thread.sticky) ? _c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.updateThread({
            sticky: true,
            id: thread.id
          })
        }
      }
    }, [_vm._v("Stick")]) : _vm._e(), _vm._v(" "), (thread.sticky) ? _c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.updateThread({
            sticky: false,
            id: thread.id
          })
        }
      }
    }, [_vm._v("Unstick")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_vm._v("\n                            by\n                            "), _c('span', {
      staticClass: "post-author-link"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'posts-by-user',
          query: {
            userId: thread.latestPost.poster.id
          }
        }
      }
    }, [_c('img', {
      staticClass: "role-icon",
      attrs: {
        "src": _vm._f("roleIcon")(thread.latestPost.poster.roles, thread.latestPost.poster.terms)
      }
    }), _vm._v("\n                                    " + _vm._s(thread.latestPost.poster.firstName) + " " + _vm._s(thread.latestPost.poster.lastName)), _c('br')])], 1), _vm._v("\n                            " + _vm._s(_vm._f("timeago")(thread.latestPost.createdAt)) + "\n\n                        ")])]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.totalPages > 1) ? _c('ul', {
    staticClass: "forum-pagination"
  }, [_c('li', [_c('a', {
    staticClass: "previous-page",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setPage(_vm.currentPage - 1)
      }
    }
  }, [_vm._v("«")])]), _vm._v(" "), _vm._l((_vm.totalPages), function(i) {
    return _c('li', [_c('a', {
      class: {
        'current-page': i === (_vm.currentPage + 1)
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.currentPage = (i - 1)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(i) + "\n                        ")])])
  }), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "previous-page",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setPage(_vm.currentPage + 1)
      }
    }
  }, [_vm._v("»")])])], 2) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel new-thread"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Post New Thread"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Add a new thread to this sub-forum below.'),
      expression: "'Add a new thread to this sub-forum below.'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.postTopic()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.topic.title),
      expression: "topic.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Title"
    },
    domProps: {
      "value": (_vm.topic.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.topic.title = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.localStorage.roles.indexOf('Student') > -1) ? _c('div', {
    staticClass: "form-group col-sm-12 nopad categories"
  }, [_c('label', [_vm._v("Categories")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCategories.term),
      expression: "selectedCategories.term"
    }],
    staticClass: "form-control",
    class: {
      'placeholder': _vm.selectedCategories.term === ''
    },
    attrs: {
      "placeholder": "Term"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCategories.term = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "default": "",
      "disabled": ""
    }
  }, [_vm._v("Term")]), _vm._v(" "), _vm._l((_vm.categories.term), function(term) {
    return _c('option', {
      domProps: {
        "value": term.id
      }
    }, [_vm._v("\n                                    " + _vm._s(term.name) + "\n                                ")])
  })], 2)]), _vm._v(" "), (_vm.selectedTermType !== 'foundation') ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCategories.path),
      expression: "selectedCategories.path"
    }],
    staticClass: "form-control",
    class: {
      'placeholder': _vm.selectedCategories.path === ''
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCategories.path = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "default": ""
    }
  }, [_vm._v("Learning Path")]), _vm._v(" "), _vm._l((_vm.categories.path), function(path) {
    return _c('option', {
      domProps: {
        "value": path.id
      }
    }, [_vm._v("\n                                    " + _vm._s(path.name) + "\n                                ")])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCategories.assignment),
      expression: "selectedCategories.assignment"
    }],
    staticClass: "form-control",
    class: {
      'placeholder': _vm.selectedCategories.assignment === ''
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCategories.assignment = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "default": ""
    }
  }, [_vm._v("Assignment")]), _vm._v(" "), _vm._l((_vm.categories.assignment), function(assignment) {
    return (_vm.canSeeAssignment(assignment)) ? _c('option', {
      domProps: {
        "value": assignment.id
      }
    }, [_vm._v("\n                                    " + _vm._s(assignment.name) + "\n                                ")]) : _vm._e()
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tags")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "tags",
      "type": "text",
      "placeholder": "Type a tag and press Enter or select one from the list"
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.addTag()
      }
    }
  }), _vm._v(" "), _c('typeahead', {
    ref: "typeahead",
    attrs: {
      "target": "#tags",
      "match-start": "",
      "data": _vm.tags,
      "item-key": "name"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return _vm._l((props.items), function(item, index) {
          return _c('li', {
            class: {
              active: props.activeIndex === index
            }
          }, [_c('a', {
            attrs: {
              "role": "button"
            },
            on: {
              "click": function($event) {
                _vm.pushTag(item);
                _vm.newTag = null
              }
            }
          }, [_vm._v("\n                                        " + _vm._s(_vm._f("ucwords")(item.name)) + "\n                                    ")])])
        })
      }
    }]),
    model: {
      value: (_vm.newTag),
      callback: function($$v) {
        _vm.newTag = $$v
      },
      expression: "newTag"
    }
  })], 1), _vm._v(" "), _c('ul', {
    staticClass: "post-tags clearfix"
  }, _vm._l((_vm.postTags), function(tag, $index) {
    return _c('li', [_vm._v(_vm._s(_vm._f("ucwords")(tag.name))), _c('span', {
      staticClass: "remove",
      on: {
        "click": function($event) {
          _vm.postTags.splice($index, 1)
        }
      }
    }, [_vm._v("x")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('vue-html5-editor', {
    attrs: {
      "content": _vm.content,
      "height": 200
    },
    on: {
      "change": _vm.updateContent
    }
  })], 1), _vm._v(" "), _vm._m(1)])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "clearfix forum-thread-header"
  }, [_c('div', {
    staticClass: "col-xs-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5"
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_vm._v("Statistics")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_vm._v("Last Post")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "value": "Submit"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-74a79e5c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Discussion.vue
// module id = 2079
// module chunks = 2